module.exports = __webpack_public_path__ + "static/media/santiagopulidop.8f28adfb.jpg";